export const headerList = [
    {
        prop: "orderNumber",
        label: "序号",
        width: 80,
    },
    {
        prop: "videoInfo",
        label: "视频",
    },
    // {
    //     prop: "dataInfo",
    //     label: "点赞数/评论数/下载数",
    //     width: 230
    // },
    {
        prop: "status",
        label: "小程序挂载状态",
        width: 130,
    },
]